import { Injectable } from '@angular/core';
import { SHARED_BUSINESS_FLOW_PROCESS_FLOW_B_VERIFICATION_TYPE } from '@libs/shared/domain/patient-assistance/business-flow/process-flow/b-verification/shared-business-flow-process-flow-b-verification.type';
import { SHARED_BUSINESS_FLOW_PROCESS_FLOW_CUSTOMER_SUPPORT_TYPE } from '@libs/shared/domain/patient-assistance/business-flow/process-flow/customer-support/shared-business-flow-process-flow-customer-support.type';
import { SHARED_BUSINESS_FLOW_PROCESS_FLOW_PHARMACY_PAYMENT_ENROLLMENT_TYPE } from '@libs/shared/domain/patient-assistance/business-flow/process-flow/pharmacy-payment-enrollment/shared-business-flow-process-flow-pharmacy-payment-enrollment.type';
import { AuthGuard } from '@services/guards/auth-guard';

@Injectable({ providedIn: 'root' })
export class AuthWorkflowGuard extends AuthGuard {
  async isAccessGranted(routeUrl: string, featureFlagKey: string, params: Record<string, string>) {
    const access = await super.isAccessGranted(routeUrl, featureFlagKey, params);
    const granted = access && (await this.isWorkflowAvailable(params));

    if (!granted) console.warn('AuthWorkflowGuard', params);

    return granted;
  }

  async isWorkflowAvailable(params: Record<string, string>) {
    let isAvaliable = true;
    const businessFlowType = params.businessFlowType;

    if (!businessFlowType) {
      console.error('AuthWorkflowGuard: Param businessFlowType is required', businessFlowType);
      return false;
    }

    switch (businessFlowType) {
      case SHARED_BUSINESS_FLOW_PROCESS_FLOW_PHARMACY_PAYMENT_ENROLLMENT_TYPE:
        isAvaliable = this.userService.isSuperAdmin() && this.featureFlagsService.isOn('workflow-pharmacy-payment-enrollment-enabled');
        break;
      case SHARED_BUSINESS_FLOW_PROCESS_FLOW_CUSTOMER_SUPPORT_TYPE:
        isAvaliable = this.userService.isSuperAdmin() && this.featureFlagsService.isOn('workflow-customer-support-enabled');
        break;
      case SHARED_BUSINESS_FLOW_PROCESS_FLOW_B_VERIFICATION_TYPE:
        isAvaliable = this.userService.isSuperAdmin() && this.featureFlagsService.isOn('workflow-b-verification-enabled');
        break;
      default:
        isAvaliable = false;
        break;
    }

    return isAvaliable;
  }
}
